export * from './about/about.component';
export * from './home/home.component';
export * from './not-found/not-found.component';
export * from './privacy/privacy.component';
export * from './methodology/methodology.component';
export * from './services/services.component';